import { render, staticRenderFns } from "./TourismClassify.vue?vue&type=template&id=5e038c10&scoped=true&"
import script from "./TourismClassify.vue?vue&type=script&lang=js&"
export * from "./TourismClassify.vue?vue&type=script&lang=js&"
import style0 from "./TourismClassify.vue?vue&type=style&index=0&id=5e038c10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e038c10",
  null
  
)

export default component.exports